// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--1ynF7","button404":"button-module--button-404--xYuvG"};